import type {
  DefaultSectionT,
  SectionListProps,
  FlatListProps,
} from 'react-native'
import type * as ReactNativeTabView from 'react-native-tab-view/lib/typescript/src/types'

export const enum SceneTypes {
  SectionList = 'SectionList',
  FlatList = 'FlatList',
}

export type RouteWithSceneType<T extends SceneTypes = SceneTypes> =
  ReactNativeTabView.Route & {
    sceneType: T
  }

type SectionListRoute = RouteWithSceneType<SceneTypes.SectionList>

export type SectionListTab<
  TItem,
  TSection extends DefaultSectionT = DefaultSectionT
> = Pick<
  SectionListProps<TItem, TSection>,
  'renderItem' | 'sections' | 'renderSectionHeader'
> &
  SectionListRoute

type FlatListRoute = RouteWithSceneType<SceneTypes.FlatList>

export type FlatListTab<ItemT> = Pick<
  FlatListProps<ItemT>,
  'renderItem' | 'data' | 'numColumns'
> &
  FlatListRoute

export type Tabs = (SectionListTab<any, any> | FlatListTab<any>)[]

export type Scene = SectionListRoute | FlatListRoute
